// Central mapping from form values to backend payload image_config

const FIELD_MAPPING = {
  assetHash: {backendKey: 'asset_hash', type: 'string'},
  autoNegate: {backendKey: 'auto_negate', type: 'binary'},
  colorId: {backendKey: 'color_id', type: 'nullable_string'},
  debopacity: {backendKey: 'debopacity', type: 'number'},
  design: {backendKey: 'design', type: 'string'},
  digest: {backendKey: 'digest', type: 'string'},
  imdeboss: {backendKey: 'imdeboss', type: 'binary'},
  imengrave: {backendKey: 'imengrave', type: 'binary'},
  ixbg: {backendKey: 'ixbg', type: 'string'},
  ixfm: {backendKey: 'ixfm', type: 'string'},
  ixh: {backendKey: 'ixh', type: 'number'},
  ixq: {backendKey: 'ixq', type: 'number'},
  ixw: {backendKey: 'ixw', type: 'number'},
  noauto: {backendKey: 'noauto', type: 'binary'},
  opacity: {backendKey: 'opacity', type: 'number'},
  placeMax: {backendKey: 'place_max', type: 'binary'},
  placeMaxCenter: {backendKey: 'place_max_center', type: 'number'},
  placeMaxPct: {backendKey: 'place_max_pct', type: 'number'},
  placeUseProduct: {backendKey: 'place_use_product', type: 'binary'},
  placeUseView: {backendKey: 'place_use_view', type: 'string'},
  useLabImage: {backendKey: 'use_lab_image', required: true, type: 'binary'}
};

function shouldIncludeField(value, type) {
  switch (type) {
    case 'string':
      return Boolean(value);
    case 'nullable_string':
      return value !== undefined;
    case 'binary':
      return value !== undefined;
    case 'number':
      return value !== undefined && value !== null;
    default:
      return false;
  }
}

function transformValue(value, type) {
  switch (type) {
    case 'binary':
      return value ? 1 : 0;
    case 'string':
    case 'nullable_string':
    case 'number':
    default:
      return value;
  }
}

export function mapFormToBackend(formData) {
  const imageConfig = {};
  Object.entries(FIELD_MAPPING).forEach(([frontendKey, config]) => {
    const value = formData[frontendKey];
    if (config.required || shouldIncludeField(value, config.type)) {
      imageConfig[config.backendKey] = transformValue(value, config.type);
    }
  });
  return {image_config: imageConfig};
}

export default mapFormToBackend;
